import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

function YourDataDeliveryDate(props) {
  const { start, end, product } = props;
  const isDirectmarketing = product === 'direktvermarktung';
  if (!end) {
    return (
      <FormattedMessage
        id={
          !isDirectmarketing
            ? 'offerWizard.yourData.deliveryDateShort'
            : 'offerWizard.yourData.deliveryDateShort.directmarketing'
        }
        values={{
          start: moment(start).format('DD.MM.YYYY'),
        }}
      />
    );
  }
  return (
    <FormattedMessage
      id={
        !isDirectmarketing
          ? 'offerWizard.yourData.deliveryDate'
          : 'offerWizard.yourData.deliveryDate.directmarketing'
      }
      values={{
        start: moment(start).format('DD.MM.YYYY'),
        end: moment(end).format('DD.MM.YYYY'),
      }}
    />
  );
}

YourDataDeliveryDate.defaultProps = {
  end: null,
};

YourDataDeliveryDate.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string,
  product: PropTypes.string.isRequired,
};

export default YourDataDeliveryDate;
